import {
	AT,
	REQUEST_PREFIX,
	SUCCESS_PREFIX,
	FAIL_PREFIX,
	SUCCESS_SUFFIX,
	FAIL_SUFFIX,
	ApiActionType,
	ApiRequestAction,
	ApiSuccessValue,
	ApiFailValue,
} from "./ActionTypeConstants";

export const getSuccessActionValue = (
	requestType: ApiRequestAction
): ApiSuccessValue | null => {
	const requestAction = requestType.replace(
		REQUEST_PREFIX,
		""
	) as ApiActionType;

	if (!(`${requestAction}${SUCCESS_SUFFIX}` in AT)) {
		return null;
	}
	return `${SUCCESS_PREFIX}${requestAction}`;
};

export const getFailActionValue = (
	requestType: ApiRequestAction
): ApiFailValue | null => {
	const requestAction = requestType.replace(
		REQUEST_PREFIX,
		""
	) as ApiActionType;

	if (!(`${requestAction}${FAIL_SUFFIX}` in AT)) {
		return null;
	}
	return `${FAIL_PREFIX}${requestAction}`;
};
